import type { ReactNode } from "react";
import { IoChevronDown } from "react-icons/io5";
import styles from "./OrgAgent.module.css";

export interface CreateAccordionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
}

export function CreateAccordion({
  title,
  isOpen,
  onToggle,
  children,
}: CreateAccordionProps) {
  const panelId = `${title.replace(/\s+/g, "-").toLowerCase()}-panel`;

  return (
    <div className={styles.createAccordion}>
      <button
        type="button"
        className={styles.createAccordionHeader}
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={onToggle}
      >
        <span>{title}</span>
        <IoChevronDown
          className={isOpen ? styles.chevronOpen : styles.chevron}
          aria-hidden
        />
      </button>
      {isOpen && (
        <div id={panelId} className={styles.createAccordionBody}>
          {children}
        </div>
      )}
    </div>
  );
}
